import React from 'react';
import moment from 'moment/moment';
import {withNamespaces} from 'react-i18next';

const AbroadDetail = ({ request,t }) => (
  <div>
    <div className="content table-responsive table-full-width">
      <table className="table table-hover table-bordered">
        <thead>
          <tr className="table-info">
            <td colSpan="2">
              <b id="costDetailAbroad">
                {t("overseas")}
              </b>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {t("jobStartDate")}
            </td>
            <td id="abroadDetailWorkStartDateAndHour">
              {moment(request.abroad.workStartDate).format('DD-MM-YYYY')}
              {' '}
              {request.abroad.workStartHour}
            </td>
          </tr>
          <tr>
            <td>
              {t("countryOfDestination")}
            </td>
            <td id="abroadDetailCountry">
              {request.abroad.country}
            </td>
          </tr>
          <tr>
            <td>
              {t("passportNo")}
            </td>
            <td id="abroadDetailPassportNo">
              {request.abroad.passportNo}
            </td>
          </tr>
          <tr>
            <td>
              {t("visa")}
            </td>
            <td id="abroadDetailVisa">
              {request.abroad.visa.value === 'var' ? 'Var' : request.abroad.visa.value === 'yok'
                  ? 'Yok': request.abroad.visa.value === 'vize_gerekmiyor' ? 'Vize Gerekmiyor' : ''}
            </td>
          </tr>
          <tr>
            <td>
              {t("peopleTravelingTogether")}
            </td>
            <td>
              <span id="abroadDetailRoadFriends">
                {request.abroad.roadFriends}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              {t("reasonForTravel")}
            </td>
            <td id="abroadDetailTravelReasons">
              {request.travelReasons.map((reason, index) => (
                <span key={reason.value}>
                  {reason.label}
                  {index !== request.travelReasons.length - 1 ? ',' : null}
                </span>
              ))}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);
export default  withNamespaces()(AbroadDetail);



// WEBPACK FOOTER //
// ./src/components/abroad/detail/index.js